<template>
  <div>
    <div class="box-write">
      <div class="wrap-write">
        <div class="title-write">발행일시</div>
        <div class="content-write">{{ this.utilityData.created_at }}</div>
      </div>
    </div>
    <div class="box-write">
      <div class="wrap-write">
        <div class="title-write">썸네일</div>
        <div class="content-write">
          <div class="img-thumbnail" :style="`background-image: url(${returnThumbnailImg(this.utilityData)})`"></div>
        </div>
      </div>
    </div>

    <div class="box-write">
      <div class="wrap-write">
        <div class="title-write">유틸리티명</div>
        <div class="content-write">{{ this.utilityData.u_name }}</div>
      </div>
    </div>

    <div class="box-write">
      <div class="wrap-write half">
        <div class="title-write">컬렉션</div>
        <div class="content-write">{{ this.utilityData.c_title }}</div>
      </div>
      <div class="wrap-write half">
        <div class="title-write">디렉터</div>
        <div class="content-write">{{ this.utilityData.director_nick }}</div>
      </div>
    </div>

    <div class="box-write">
      <div class="wrap-write half">
        <div class="title-write">상위 카테고리</div>
        <div class="content-write">{{ this.utilityData.parent_uc_name }}</div>
      </div>
      <div class="wrap-write half">
        <div class="title-write">하위 카테고리</div>
        <div class="content-write">{{ this.utilityData.uc_name }}</div>
      </div>
    </div>

    <div class="box-write">
      <div class="wrap-write half">
        <div class="title-write">사용횟수</div>
        <div class="content-write">{{ this.utilityData.u_use_total }}</div>
      </div>
      <div class="wrap-write half">
        <div class="title-write">발행개수</div>
        <div class="content-write">{{ this.utilityData.selled_cnt }}</div>
      </div>
    </div>

    <div class="box-write">
      <div class="wrap-write half">
        <div class="title-write">판매기간</div>
        <div class="content-write">{{ this.utilityData.u_sell_start_date }} - {{ this.utilityData.u_sell_end_date }}</div>
      </div>
      <div class="wrap-write half">
        <div class="title-write">판매상태</div>
        <div class="content-write">{{ returnState('sell', this.utilityData.u_sell_start_date, this.utilityData.u_sell_end_date) }}</div>
      </div>
    </div>

    <div class="box-write">
      <div class="wrap-write half">
        <div class="title-write">사용기한</div>
        <div class="content-write">{{ this.utilityData.u_use_start_date }} - {{ this.utilityData.u_use_end_date }}</div>
      </div>
      <div class="wrap-write half">
        <div class="title-write">사용상태</div>
        <div class="content-write">{{ returnState('use', this.utilityData.u_use_start_date, this.utilityData.u_use_end_date) }}</div>
      </div>
    </div>

    <div class="box-write">
      <div class="wrap-write">
        <div class="title-write">유틸리티 설명</div>
        <div class="content-write">
          {{ this.utilityData.u_detail }}
        </div>
      </div>
    </div>
  </div>

</template>

<script>

import dateMixins from "@/mixins/dateMixins";
import util from "@/mixins/util";

export default {
  name: "UtilityDetailDefaultLayout",
  mixins: [dateMixins],
  components: {},
  inject: [],
  provide() {
    return {};
  },
  props: {
    utilityData: {
      default: {
      },
    },
    utilTopCategory: {
      default: () => {
        return [];
      },
    },
    utilBottomCategory: {
      default: () => {
        return [];
      },
    },
  },
  data() {
    return {

    };
  },
  beforeRouterEnter() {
  },
  created() {
  },
  mounted() {
  },
  beforeUnmount() {
  },
  unmounted() {
  },
  computed: {},
  methods: {
    returnState(type, start, end) {
      let now = this.returnDateTime(new Date());

      if (type == 'sell') {
        if (start > now) {
          return '판매대기';
        } else if (start < now && end > now) {
          return '판매중';
        } else if (end < now) {
          return '판매종료';
        }
      } else if (type == 'use') {
        if (start > now) {
          return '사용대기';
        } else if (start < now && end > now) {
          return '사용가능';
        } else if (end < now) {
          return '기한만료';
        }
      }
    },
    returnThumbnailImg(data) {
      if (!util.isEmpty(data.UtilityImg)) {
        return data.UtilityImg[0].org_url;
      } else {
        return '';
      }
    },

  },
  watch: {},
};
</script>

<style lang="scss"></style>
